import React from 'react';
import { getFunctions, httpsCallable } from 'firebase/functions';
import ProgressBar from '../ProgressBar';
import NotificationOptInBanner from '../NotificationOptInBanner';
import { trackEvent } from '../../analytics';

const AnalysisPanels = ({
    currentProject,
    isAnalysisPending,
    analysisEta,
    stoppingTask,
    onStopClick,
    projectId,
}) => {
    return (
        <>
            {(isAnalysisPending || currentProject.video?.status === 'analyzing' || currentProject.video?.status === 'queued') &&
                <div className="pv-full-width">
                    <p className="pv-status-label">Analyzing Video</p>
                    <ProgressBar
                        progress={isAnalysisPending ? 100 : currentProject.video.progress}
                        shimmer={isAnalysisPending || currentProject.video?.status === 'queued'}
                        timeRemaining={(!isAnalysisPending && currentProject.video?.status === 'analyzing') ? analysisEta : null}
                        stopButton={!isAnalysisPending ? (
                            <button
                                className="btn-stop"
                                disabled={stoppingTask === 'analysis'}
                                onClick={() => onStopClick('analysis')}
                            >
                                <span className="stop-icon"></span>
                                {stoppingTask === 'analysis' ? 'Stopping...' : 'Stop'}
                            </button>
                        ) : null}
                    />
                    <NotificationOptInBanner event="analysis_complete" />
                </div>
            }

            {currentProject.video?.status === 'failed' &&
                <div className="pv-full-width pv-analysis-failed">
                    <h4 className="pv-analysis-failed-title">Video Analysis Failed</h4>
                    <p className="pv-analysis-failed-message">There was an error analyzing your video.</p>
                    {currentProject.video.error && <p className="pv-analysis-failed-error-details">Error Details: {currentProject.video.error}</p>}
                    <div className="pv-analysis-failed-actions">
                        <button
                            className="btn btn-teal"
                            onClick={async () => {
                                try {
                                    const functions = getFunctions();
                                    const retryAnalysis = httpsCallable(functions, 'retry_analysis');
                                    await retryAnalysis({ projectId });
                                    trackEvent('retry_analysis', { project_id: projectId });
                                } catch (error) {
                                    console.error("Error retrying analysis:", error);
                                    trackEvent('retry_analysis_error', { project_id: projectId, error: error.message });
                                    alert("An error occurred while retrying analysis. Please try again.");
                                }
                            }}
                        >
                            Retry Analysis
                        </button>
                    </div>
                </div>
            }

            {currentProject.video?.status === 'cancelled' &&
                <div className="pv-full-width pv-task-cancelled">
                    <span className="pv-task-cancelled-text">Analysis stopped</span>
                    <span className="pv-task-cancelled-separator">·</span>
                    <button
                        className="pv-task-cancelled-action"
                        onClick={async () => {
                            try {
                                const functions = getFunctions();
                                const retryAnalysis = httpsCallable(functions, 'retry_analysis');
                                await retryAnalysis({ projectId });
                                trackEvent('restart_analysis_after_cancel', { project_id: projectId });
                            } catch (error) {
                                console.error("Error restarting analysis:", error);
                                alert("An error occurred while restarting analysis. Please try again.");
                            }
                        }}
                    >
                        Restart Analysis
                    </button>
                </div>
            }
        </>
    );
};

export default AnalysisPanels;
